export function scrollToTop(value) {
    if (value) {
        document.body.scrollTop = value;
        document.documentElement.scrollTop = value;
    } else {
        if (document.documentElement.scrollTop == 0) {
            document.body.scrollTop = 0;
        } else {
            document.documentElement.scrollTop = 0;
        }
    }
};

// 检测如果为移动设备，直接跳转到移动设备
export function checkUserAgent() {
    var ua = navigator.userAgent.toLowerCase();
    var platform = navigator.platform.toLowerCase();

    // ipad下 如果像素在1280则不跳转
    if (/ipad/i.test(ua) && window.screen.width >= 1280) {
        return;
    } else if (/mobile|android|iphone|ipad|phone|MicroMessenger/i.test(ua)) {
        window.location.href = 'https://m.knowbox.cn';
    } else if (platform.indexOf('linux') !== -1) {
        window.location.href = 'https://m.knowbox.cn';
    }
};

export function resize() {
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    if (!window.addEventListener) {
        return;
    }

    window.addEventListener(resizeEvt, function() {
        checkUserAgent();
    });
};

// 指定模块在页面中的坐标位置
export const coordMaps = {
    // 发展历程
    history: 610,

    // 领导团队
    // leader: 1327,
    leader: 400,

    // 学生端
    student: 990,

    // 老师端
    teacher: 0,

    // 家长端
    parent: 1850,

    // 新家长端
     parentnew: 2661,

    // 小象科学
    science: 3980,

    // 小象英语 
    english: 4675,

    // 拍作业
    ocr: 3980 
    // ocr: 5340
}
